// Serviço centralizado para gerenciamento do localStorage no Dashboard
import { STORAGE_KEYS } from "../utils/constants";
import logger from "../../../utils/logger";

export const storageService = {
  /**
   * Recupera a região atual
   * @returns {string|null} Região ou null
   */
  getRegion: () => {
    return localStorage.getItem(STORAGE_KEYS.REGION);
  },

  /**
   * Recupera plots salvos
   * @returns {Array} Array de plots ou array vazio
   */
  getPlots: () => {
    try {
      const plots = localStorage.getItem(STORAGE_KEYS.ALL_PLOTS);
      if (!plots) return [];

      const parsed = JSON.parse(plots);
      
      // Garantir que seja um array
      if (Array.isArray(parsed)) {
        return parsed;
      }
      
      // Se for objeto, tentar extrair arrays
      if (typeof parsed === "object" && parsed !== null) {
        const region = storageService.getRegion();
        
        // Tentar pegar da região específica
        if (region && parsed[region] && Array.isArray(parsed[region])) {
          return parsed[region];
        }
        
        // Tentar encontrar qualquer array dentro do objeto
        const values = Object.values(parsed);
        const arrays = values.filter(item => Array.isArray(item));
        if (arrays.length > 0) {
          return arrays.flat();
        }
      }
      
      return [];
    } catch (error) {
      logger.error("Erro ao parsear plots", error);
      return [];
    }
  },

  /**
   * Recupera ocorrências únicas salvas
   * @returns {Array} Array de ocorrências ou array vazio
   */
  getUniqueOccurrences: () => {
    try {
      const occurrences = localStorage.getItem(STORAGE_KEYS.UNIQUE_OCCURRENCES);
      if (!occurrences) return [];
      return JSON.parse(occurrences);
    } catch (error) {
      logger.error("Erro ao parsear ocorrências", error);
      return [];
    }
  },

  /**
   * Salva ocorrências únicas
   * @param {Array} occurrences - Array de ocorrências
   */
  setUniqueOccurrences: (occurrences) => {
    localStorage.setItem(STORAGE_KEYS.UNIQUE_OCCURRENCES, JSON.stringify(occurrences));
  },

  /**
   * Recupera ocorrências ordenadas
   * @returns {Array} Array de ocorrências ordenadas ou array vazio
   */
  getOccurrencesSort: () => {
    try {
      const occurrences = localStorage.getItem(STORAGE_KEYS.OCCURRENCES_SORT);
      if (!occurrences) return [];
      return JSON.parse(occurrences);
    } catch (error) {
      logger.error("Erro ao parsear ocorrências ordenadas", error);
      return [];
    }
  },

  /**
   * Salva ocorrências ordenadas
   * @param {Array} occurrences - Array de ocorrências ordenadas
   */
  setOccurrencesSort: (occurrences) => {
    localStorage.setItem(STORAGE_KEYS.OCCURRENCES_SORT, JSON.stringify(occurrences));
  },

  /**
   * Recupera registros para convite (offline)
   * @returns {Array|null} Array de registros ou null
   */
  getRegistersToInvite: () => {
    try {
      const registers = localStorage.getItem(STORAGE_KEYS.REGISTERS_TO_INVITE);
      if (!registers) return null;
      return JSON.parse(registers);
    } catch (error) {
      logger.error("Erro ao parsear registros para convite", error);
      return null;
    }
  },

  /**
   * Remove registros para convite
   */
  removeRegistersToInvite: () => {
    localStorage.removeItem(STORAGE_KEYS.REGISTERS_TO_INVITE);
  }
};

